import { render } from "./BlockVariableFields.vue?vue&type=template&id=39f03d79&scoped=true"
import script from "./BlockVariableFields.vue?vue&type=script&lang=js"
export * from "./BlockVariableFields.vue?vue&type=script&lang=js"

import "./BlockVariableFields.vue?vue&type=style&index=0&id=39f03d79&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f03d79"]])

export default __exports__